const getStatistics = (users) => {
  const totalUsers = users?.length;

  let segmentStats = {
    regular: 0,
    chilled: 0,
    mild: 0,
    sprint: 0,
    alert: 0,

    triedButFailed: 0,
    neverTried: 0
  };

  let conversionStats = {
    conversion: 0,
    nonConversion: 0
  };

  users.forEach((user) => {
    const { segment, conversionType } = user ?? {};

    if (segment) {
      segmentStats = { ...segmentStats, [segment]: segmentStats[segment] + 1 };
    }

    if (conversionType) {
      conversionStats.conversion = conversionStats.conversion + 1;
    } else {
      conversionStats.nonConversion = conversionStats.nonConversion + 1;
    }
  });

  const notConnectedStats = {
    triedButFailed: segmentStats.triedButFailed,
    neverTried: segmentStats.neverTried
  };

  const metrics = Object.assign({}, { ...segmentStats });

  delete metrics.triedButFailed;
  delete metrics.neverTried;

  const totalConnected = Object.values(metrics).reduce((total, current) => total + current, 0);
  const totalNotConnected = Object.values(notConnectedStats).reduce(
    (total, current) => total + current,
    0
  );

  const totalConnectedPercent =
    totalUsers > 0 ? Math.floor((totalConnected / totalUsers) * 100) : 0;
  const totalNotConnectedPercent = totalUsers > 0 ? 100 - totalConnectedPercent : 0;

  const chartData = [
    {
      metrics
    }
  ];

  const result = {
    totalUsers,
    totalConnected,
    totalNotConnected,
    totalConnectedPercent,
    totalNotConnectedPercent,
    conversionStats,
    chartData,
    notConnectedStats
  };

  return result;
};

export const userStatisticsUtils = { getStatistics };
